const activities = [{
  desc: '查询当前用户能看到的所有活动列表',
  options: {
    url: '/matchPlatform/queryMatchActivityPageList',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '抽奖记录',
  options: {
    url: '/matchPlatform/queryRedEnvelopeRecord',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '获取抽奖次数接口',
  options: {
    url: '/matchPlatform/queryNumberOfLuckyDraw',
    method: 'get',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '抽奖',
  options: {
    url: '/matchPlatform/luckDraw',
    method: 'get',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '活动根据保司显示',
  options: {
    url: '/marketProgram/queryInsSupplierActivityList',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}, {
  desc: '非车红包活动',
  options: {
    url: '/marketProgram/showProductRed',
    method: 'get',
    baseURL: '/insapi/v3/youbaolian-marketprogram'
  }
}]
export default activities



// WEBPACK FOOTER //
// ./src/api/activities.js